/* eslint-disable react/prop-types */
import { colors, darkModeColors, strCode } from "../../../consts";
import { t } from "../../../services";

import SVG from "../../../components/SVG/icons";
import { Paragraph2 } from "../../../components/Text/Paragraphs";
import TextOverflowWrapper from "../../../components/TextOverflowWrapper/TextOverflowWrapper";

import { CellWrapper, EmptyCell } from "../../../components/Table/styled";

const checkEmpty = (Component, value, danger = true) => {
  return value ? Component : <EmptyCell danger={danger}>{t(strCode.EMPTY_CELL_INFO)}</EmptyCell>;
};

export const ImportedUsersTableColumns = [
  {
    Header: "#",
    accessor: "index",
    Cell: ({ cell }) => (
      <CellWrapper width={`fit-content`}>
        <Paragraph2>
          <b>{cell.value}</b>
        </Paragraph2>
      </CellWrapper>
    )
  },
  {
    Header: strCode.USERNAME_TITLE,
    accessor: "email",
    Cell: ({ cell, ...rest }) => {
      return (
        <CellWrapper width="180px">
          {checkEmpty(
            <TextOverflowWrapper
              style={{
                fontWeight: "700",
                color: rest?.row?.original?.active
                  ? darkModeColors.RAISIN_100_WHITE
                  : colors.RAISIN_50
              }}>
              {cell.value}
            </TextOverflowWrapper>,
            cell.value
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ROLES_TITLE,
    accessor: "group",
    Cell: ({ cell }) => (
      <CellWrapper width="140px">
        {checkEmpty(
          <TextOverflowWrapper lines={2} maxWidth="140px">
            {cell.value?.join(", ")}
          </TextOverflowWrapper>,
          cell.value
        )}
      </CellWrapper>
    )
  },
  {
    Header: strCode.ACTIVE_FROM_TITLE,
    accessor: "stringActiveFrom",
    Cell: ({ cell }) => {
      return (
        <CellWrapper width="140px">
          {checkEmpty(
            <TextOverflowWrapper lines={2} maxWidth="140px">
              {cell.value}
            </TextOverflowWrapper>,
            cell.value
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ACTIVE_TO_TITLE,
    accessor: "stringActiveTo",
    Cell: ({ cell }) => (
      <CellWrapper width="140px">
        {checkEmpty(
          <TextOverflowWrapper lines={2} maxWidth="140px">
            {cell.value}
          </TextOverflowWrapper>,
          cell.value
        )}
      </CellWrapper>
    )
  },
  {
    Header: strCode.APP_TYPES_TITLE,
    accessor: "appType",
    Cell: ({ cell }) => (
      <CellWrapper width="128px">
        {checkEmpty(
          <TextOverflowWrapper>{cell.value?.join(", ")}</TextOverflowWrapper>,
          cell.value
        )}
      </CellWrapper>
    )
  },
  {
    Header: strCode.LOCATIONS_TITLE,
    accessor: "locationName",
    Cell: ({ cell }) => (
      <CellWrapper width="52px">
        {checkEmpty(
          <TextOverflowWrapper>{cell.value?.join(", ")}</TextOverflowWrapper>,
          cell.value,
          false
        )}
      </CellWrapper>
    )
  },
  {
    Header: strCode.MARKET_TITLE,
    accessor: "market",
    Cell: ({ cell }) => (
      <CellWrapper width="52px">
        {checkEmpty(
          <TextOverflowWrapper>{cell.value?.join(", ")}</TextOverflowWrapper>,
          cell.value
        )}
      </CellWrapper>
    )
  },
  {
    id: "status",
    accessor: "correct",
    Cell: ({ cell }) => (
      <CellWrapper width={`16px`}>
        {cell?.value ? (
          <SVG.NotificationSuccessIcon size={16} />
        ) : (
          <SVG.NotificationErrorIcon size={16} />
        )}
      </CellWrapper>
    )
  }
];
